import { Typography } from "@mui/material"

interface FormValidationErrorMessageProps {
    message: string
    validationErrors: string[]
}

function FormValidationErrorMessage({ message, validationErrors }: FormValidationErrorMessageProps) {
  return (
    <Typography style={{ fontSize: '13px', whiteSpace: 'pre-wrap' }}>
      {message}
      <ul>
        { validationErrors.map(error => (
          <li>{error}</li>
        ))}
      </ul>
    </Typography>
  )
}

export default FormValidationErrorMessage